export const lang = {
  name: "name",
};
